import { styled } from "@mui/material/styles";
import { Button, Stack, Box } from "@mui/material";
import { ReactNode } from "react";

interface StyledHRContainerProps {
  height?: string | number;
  width?: string | number;
}

interface StyledHRTextProps {
  fontFamily?: string;
  fontWeight?: number | string;
}

interface HRContainerProps extends StyledHRContainerProps, StyledHRTextProps {
  children?: ReactNode;
  text?: string;
}

export const StyledSelectRadio = styled("div")(({ theme }) => ({
  background: theme.palette.common.background.light,
  border: `1px solid lightGrey`,
  marginTop: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  paddingBottom: theme.spacing(0.5)
}));

export default {
  StyledSelectRadio,
};

export const StyledContainer = styled("div")(({ theme }) => ({
    width: "85%",
    backgroundColor: theme.palette.background.default,
    transition: "width 0.3s ease",
    overflow: "auto",
    paddingBottom: 5,
    paddingTop: 10,
    paddingLeft: 20,
    marginRight: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginRight: 0,
    },
}));

export const StyledMemberToExportContainer = styled(Box)(({ theme }) => ({
	overflow: "auto",
	width: "45%",
	backgroundColor: "background.paper",
  marginLeft: "auto",
  paddingRight: 10,
  paddingTop: 15,
  [theme.breakpoints.down("md")]: {
    width: "100%",
    marginLeft: 0,
    marginTop: theme.spacing(2),
  },
}));

export const StyledMemberListItem = styled(Box)(({ theme }) => ({
	padding: theme.spacing(1),
	marginBottom: theme.spacing(1),
	backgroundColor: theme.palette.background.default,
	display: "flex",
	alignItems: "center",
  justifyContent: "space-between",
  minWidth: 0,
}));

export const StyledMemberToExportDivider = styled("div")(({ theme }) => ({
	marginTop: theme.spacing(0.5),
}));

export const StyledHeader = styled("div")(({ theme }) => ({
    textAlign: "center",
    whiteSpace: "nowrap",
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  justifyContent: "left",
  width: "100%"
}));

export const StyledCheckBoxStack = styled(Stack)(({ theme }) => ({
  justifyContent: "center"
}));

const StyledHRContainer = styled("div")<StyledHRContainerProps>(
  ({ height, width }) => ({
    height,
    width: width || "100%",
  })
);

const StyledHRText = styled("p")<StyledHRTextProps>(
  ({ fontFamily, fontWeight }) => ({
    fontFamily,
    fontWeight,
    textAlign: "left",
  })
);

export const HRContainer = ({
  children,
  height,
  fontFamily,
  fontWeight,
  text,
  width,
}: HRContainerProps) => {
  return (
    <StyledHRContainer height={height} width={width} sx={{ paddingBottom: 3 }}>
      <StyledHRText fontFamily={fontFamily} fontWeight={fontWeight} sx={{ paddingLeft: 2 }}>
        {text}
      </StyledHRText>
      <hr style={{ marginBottom: '20px', width: '98%' }} />
      <Box sx={{ paddingLeft: 5 }}>
        {children}
      </Box>
    </StyledHRContainer>
  );
};

export const StyledExportButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: 0,
  fontSize: "1rem",
  padding: theme.spacing(1, 2),
  minWidth: 64,

  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },

  "&:disabled": {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.common.white,
  },
}));